import type { R2BStagingBrandEntity } from "../../entity_types/r2bStagingBrand";

export const defaultR2BStagingBrand: R2BStagingBrandEntity = {
  token: "default",
  type: "r2bStagingBrand",
  avatarUrl: "",
  name: "Default Staging Brand",
  productImageUrls: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "default-entity",
  },
};
